import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';
import { FormSpy } from 'react-final-form';

import CreateToolbar from '../../core/components/CreateToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import OrganizationSummary from './OrganizationSummary';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const OrganizationTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Investor Family"
      name=""
      status=""
      creation={true}
      statusLabel=""
      showAvatar={true}
      avatarContent={'IF'}
      recordLabel="Investor Family"
    />
  );
};

class OrganizationCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block bnavigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }
  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  render() {
    const { whenBlockNavigation } = this.state;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create {...this.props} title={<OrganizationTitle />}>
          <TabbedForm
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Investor Family Details">
              <OrganizationSummary creation={true} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  this.handleFormIsDirty(props.dirty);
                }}
              />
            </FormTab>
          </TabbedForm>
        </Create>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(OrganizationCreate);
